import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-zinc-950 text-zinc-300 flex items-center justify-center">
        <div className="text-center">
          <div className="font-mono text-xs uppercase tracking-[0.3em] text-zinc-500 mb-4">
            Vérification…
          </div>
          <div className="w-12 h-px bg-white mx-auto animate-pulse" />
        </div>
      </div>
    );
  }

  if (!user) {
    const to = requireAdmin ? "/login?from=admin" : "/login";
    return <Navigate to={to} state={{ from: location }} replace />;
  }

  if (requireAdmin && !user.is_admin) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};
